export default __webpack_public_path__ + "static/GlassdoorLogo-69d329f78c1ba48ac4fa162fd9ee0a15.png";